<template>
  <div>
    <hnavbar />
    <Content pagetitle="APPLICATION COMPLETE">
      <box boxheading="SUCCESSFULLY SUBMITTED">
        <div class="alert alert-success alert-dismissible">
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-hidden="true"
          >
            ×
          </button>
          <h4><i class="icon fa fa-check"></i> Thank you!</h4>
          <p>
            We have received your application and would like to thank you for
            writing to us. If your request is urgent, please use the telephone
            number listed below to talk to us. Otherwise, we will reply by email
            or call as soon as possible.
          </p>
        </div>
      </box>
    </Content>
  </div>
</template>

<script>
import hnavbar from "../components/HNavBar.vue";
import Content from "../components/Content.vue";
import Box from "../components/Box.vue";
export default {
  name: "Complete",
  components: {
    hnavbar,
    Content,
    Box,
  },
};
</script>

<style lang="scss" scoped></style>
